import { v4 as _uuidV4 } from 'uuid'

const uuidv4 = () => {
  return _uuidV4()
}

export default uuidv4
